module.exports = __webpack_public_path__ + "static/images/ico-paging@2x.d3f8f61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/edit/config/ico-paging@2x.png
// module id = 6kM8
// module chunks = 6 7